import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_838eh3fmdz: FaireBrandEntity = {
  token: "b_838eh3fmdz",
  type: "brand",
  name: "Snap Supplements",
  avatarUrl:
    "https://cdn.faire.com/fastly/e9335a84ddbc860b79f7c7eadd82bbabfb5d8f6681d00c4ec3f6512a90f5d91b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d53a3d21bf7b8b7522ffd2c77aa5976e1344809dd89419a01ae56c4e792c8d0e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e9335a84ddbc860b79f7c7eadd82bbabfb5d8f6681d00c4ec3f6512a90f5d91b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d53a3d21bf7b8b7522ffd2c77aa5976e1344809dd89419a01ae56c4e792c8d0e.jpeg",
  location: "Vancouver, WA, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "At Snap Supplements we believe optimizing your health should be simple. That’s why we’re committed to providing you with natural, high-quality supplements made with only the purest and carefully selected superfoods, botanicals, vitamins, and minerals formulated for optimal health impact and results.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:54.238Z",
    importedBy: "entity-db-cli",
  },
};
